import { render } from "./CompanyList.vue?vue&type=template&id=a8017c82"
import script from "./CompanyList.vue?vue&type=script&lang=ts"
export * from "./CompanyList.vue?vue&type=script&lang=ts"
script.render = render

export default script